import styled from "styled-components/macro";
import { InputStyleProps } from "./helpers";
import { fieldsBorderRadius } from "../constants";
import { colorState, spacing, typography } from "../../Foundation";

interface InputProps {
    isSearchIcon?: boolean;
}

// DOM attributes are passed automatically from props
export const Input = styled.input.attrs<InputProps>((props) => ({
    value: props.value
}))`
    padding: 10px;
    width: 100%;
    height: 38px;
    border: 1px solid
        ${(props: InputStyleProps): string => props.theme.colors.neutral.light.backgroundColor};
    color: #4d4d4d;
    letter-spacing: 0.56px;
    text-transform: ${(props: InputStyleProps): string => `${props.textTransform}`};
    border-radius: ${(props) => (props.isSearchIcon ? "100px" : fieldsBorderRadius)};

    &:active,
    &:focus {
        box-shadow: 0 1px 2px #00000029;
        border: 1px solid
            ${(props: InputStyleProps): string => {
                if (props.disabled) {
                    return props.theme.colors.neutral.light.backgroundColor;
                }

                if (props.isFailure) {
                    return "#CE2924";
                }

                return props.theme.colors.primary.main.backgroundColor;
            }};
    }

    &:disabled {
        border: 1px solid
            ${(props: InputStyleProps): string => props.theme.colors.neutral.light.backgroundColor};
    }

    &:hover {
        border: 1px solid
            ${(props: InputStyleProps): string => {
                if (props.disabled) {
                    return props.theme.colors.neutral.light.backgroundColor;
                }

                if (props.isFailure) {
                    return "#CE2924";
                }

                return props.theme.colors.primary.main.backgroundColor;
            }};
    }
`;

export const MultiInput = styled.textarea.attrs((props) => ({
    value: props.value
}))`
    padding: 10px;
    width: 100%;
    border: 1px solid #ccc;
    color: #4d4d4d;
    letter-spacing: 0.56px;
    outline-color: #4692a9;
    border-radius: ${fieldsBorderRadius};
    resize: none;
    font-family: Roboto, sans-serif;
    text-transform: ${(props: InputStyleProps): string =>
        props.textTransform ? `${props.textTransform}` : "none"};

    &:active,
    &:focus {
        box-shadow: 0 1px 1px #00000029;
        border: 1px solid;
    }

    &:disabled {
        border: 1px solid
            ${(props: InputStyleProps): string => props.theme.colors.neutral.light.backgroundColor};
    }

    &:hover {
        border: 1px solid
            ${(props: InputStyleProps): string => {
                if (props.disabled) {
                    return props.theme.colors.neutral.light.backgroundColor;
                }

                if (props.isFailure) {
                    return "#CE2924";
                }

                return props.theme.colors.primary.main.backgroundColor;
            }};
    }
`;

export const Message = styled.div<InputStyleProps>`
    font-size: 12px;
    color: ${(props: InputStyleProps): string => (props.isSuccess ? "#2D805C" : "#CE2924")};
`;

export const Icon = styled.div<InputProps>`
    padding: ${(props) => (props.isSearchIcon ? "0px" : "6px")};
    pointer-events: none;
    right: ${(props) => (props.isSearchIcon ? "3px" : "6px")};
    position: absolute;

    .search-wrapper {
        width: 40px;
        height: 32px;
        background-color: ${colorState.surface.brand.primary};
        border-radius: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const Main = styled.div`
    position: relative;
    display: flex;
    align-items: center;

    .icon-right {
        position: absolute;
        right: ${spacing.spacing_12};
        top: ${spacing.spacing_8};
    }
`;

export const Image = styled.img`
    height: 18px;
    width: 18px;
`;

export const Label = styled.label`
    font-size: ${typography.size.ts};
    color: ${colorState.text.secondary};
    font-weight: ${typography.weight.medium};
    margin: 0;
`;
